if (!customElements.get('sleepy-v4-choice')) {
  customElements.define('sleepy-v4-choice', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.details?.querySelector('summary');
      if (!this.details || !this.summary || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.preventDefault();
        this.details.open = false;
        this.summary.focus();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.details.open = false;
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('a')) this.details.open = false;
      }, options);
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
      }, options);
      this.summary.setAttribute('aria-expanded', String(this.details.open));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
